const API_BASE = import.meta.env.VITE_API_BASE || '/api'

export interface LoginCredentials {
  username: string
  password: string
}

export interface LoginResponse {
  success: boolean
  user?: {
    id: number
    username: string
    role: 'full_access' | 'view_only'
  }
  error?: string
}

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  try {
    const response = await fetch(`${API_BASE}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(credentials)
    })

    if (!response.ok) {
      if (response.status === 401) {
        return { success: false, error: 'Invalid username or password' }
      }
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return { success: true, user: data.user }
  } catch (error) {
    console.error('Login error:', error)
    return { success: false, error: 'Network error. Please try again.' }
  }
}

export async function logout(): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE}/logout`, {
      method: 'POST',
      credentials: 'include'
    })
    return response.ok
  } catch (error) {
    console.error('Logout error:', error)
    return false
  }
}

export async function checkSession(): Promise<{ authenticated: boolean; user?: { id: number; username: string; role: 'full_access' | 'view_only' } }> {
  try {
    const response = await fetch(`${API_BASE}/session`, {
      method: 'GET',
      credentials: 'include'
    })

    if (!response.ok) {
      return { authenticated: false }
    }

    const data = await response.json()
    return { authenticated: true, user: data.user }
  } catch (error) {
    console.error('Session check error:', error)
    return { authenticated: false }
  }
}
